export default "__VITE_ASSET__3e86d8fd__"